<rlst-expandable-item [title]="dataElement.label" [noTitlecase]="true" [expanded]="expanded" [disabled]="disabled"
  [rlstTooltip]="disabledMessage" tooltipPosition="above">
  <div class="js-panel-header" style="display: contents;" [formGroup]="searchList.at(0)"
    *ngIf="!isSelectableField(dataElement.displayInfo.renderId)">
    <select class="custom-select custom-select-search custom-select-rtl" name="searchOperator"
      formControlName="operator" (click)="onSelectClick($event)">
      <option *ngFor="let operator of (defaultOperatorValueList || dataElement.operatorValueList)"
        [ngValue]="operator.operator">
        {{operator.operatorLabel}}
      </option>
    </select>
    <div *ngIf="dataElement.fieldCode === 'PROPENSITY_TO_SELL_SCORE'">
      <ng-template #popTemplate>
        <div [innerHtml]="popoverHtml"></div>
      </ng-template>
      <button type="button" class="btn-custom btn-small btn-icon-only" [popover]="popTemplate" popoverTitle="SELL SCORE"
        [adaptivePosition]="false" placement="right bottom" container="body" triggers="mouseenter:mouseleave">
        <i class="far fa-info-circle" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <fieldset class="w-100 position-relative form-group"
    *ngFor="let searchFieldGroup of searchList.controls; let isFirst = first; let fieldIndex=index">
    <div class="form-group-row" [formGroup]="searchFieldGroup" *ngIf="disabled$ | async as disabled">
      <div class="form-group-row__item d-flex">
        <span class="sr-only">{{dataElement.label}} {{fieldIndex}}</span>
        <select class="custom-select custom-select-search" name="searchOperator" *ngIf="!isFirst"
          formControlName="operator">
          <option *ngFor="let operator of (defaultOperatorValueList || dataElement.operatorValueList)"
            [value]="operator.operator">
            {{operator.operatorLabel}}
          </option>
        </select>

        <div [ngSwitch]="true" class="w-100" [formGroup]="searchFieldGroup.get('values')">
          <div *ngSwitchCase="dataElement.displayInfo.renderId === RENDER_ID.CALENDAR_TOOL">
            <div *ngIf="searchFieldGroup.get('operator').value !== 'BETWEEN'" class="d-flex"
              [attr.aria-label]="dataElement.description" data-tooltip-position="above">
              <input [matDatepicker]="datePicker" [placeholder]="dataElement.displayInfo.elementMask || ''"
                class="form-control search-form-control" formControlName="valueFrom">
              <mat-datepicker-toggle [for]="datePicker" rlstTooltip="Select from calendar" tooltipPosition="above">
              </mat-datepicker-toggle>
              <mat-datepicker #datePicker [calendarHeaderComponent]="customHeader"></mat-datepicker>
            </div>
            <div *ngIf="searchFieldGroup.get('operator').value === 'BETWEEN'" class="d-flex">
              <div [attr.aria-label]="dataElement.description" data-tooltip-position="above">
                <input class="form-control search-form-control"
                  [placeholder]="dataElement.displayInfo.elementMask || ''" formControlName="valueFrom" matDatepicker>
              </div>

              <div [attr.aria-label]="dataElement.description" class="value-to-control" data-tooltip-position="above">
                <input class="form-control search-form-control"
                  [placeholder]="dataElement.displayInfo.elementMask || ''" formControlName="valueTo" matDatepicker>
              </div>

              <button mat-icon-button rlstTooltip="Select from calendar" tooltipPosition="above" type="button"
                (click)="openDateRangePicker($event, searchFieldGroup, dataElement.customAttributeInfo)">
                <img src="assets/img/datepicker.svg" alt="Select from calendar">
                <ng-content select="[matDatepickerToggleIcon]"></ng-content>
              </button>
            </div>
          </div>

          <div *ngSwitchCase="dataElement.displayInfo.renderId === RENDER_ID.DIALOGBOX_LOOKUP_WITH_DATA_LOAD ||
                              dataElement.displayInfo.renderId === RENDER_ID.DIALOGBOX_LOOKUP">
            <button *ngIf="!isLoadStarted" type="button" (click)="loadLookups()" class="btn-custom btn-small">
              <i class="far fa-search"></i> Select from list
            </button>
            <ng-container *ngIf="isLoadStarted">
              <div *ngIf="!lookups" class="loading w-100" aria-hidden="true">
                <rlst-spinner-circle panelClass="spinner-small"></rlst-spinner-circle>
              </div>
              <span [rlstTooltip]="disabled[1]" tooltipPosition="right">
                <rlst-modal-multi-select [attr.aria-label]="dataElement.description" data-tooltip-position="above"
                  [disabled]="disabled[0]" [dataElementLabel]="dataElement.label"
                  [maxNumberSelection]="dataElement.numberOfSearchValues" [lookUpData]="lookups"
                  [openModal]="openModal$ | async" formControlName="valueFrom">
                </rlst-modal-multi-select>
              </span>
            </ng-container>
          </div>
          <div *ngSwitchCase="dataElement.displayInfo.renderId === RENDER_ID.MULTI_SELECT_SEARCH_LOOKUP">
            <span [rlstTooltip]="disabled[1]" tooltipPosition="right">
              <rlst-modal-multi-select [disabled]="isControlDisabled || disabled[0]" [dataElementLabel]="dataElement.label"
                [maxNumberSelection]="dataElement.numberOfSearchValues" [isSearchableField]="true" [customAttrib]="dataElement.customAttributeInfo &&
                                      dataElement.customAttributeInfo.customAttrib1"
                [tokenNumber]="dataElement.tokenNumber" [lookUpData]="lookups || emptyLookups"
                [attr.aria-label]="dataElement.description" data-tooltip-position="above" formControlName="valueFrom">
              </rlst-modal-multi-select>
            </span>
          </div>
          <div *ngSwitchCase="dataElement.displayInfo.renderId === RENDER_ID.SINGLE_SELECT ||
                              dataElement.displayInfo.renderId === RENDER_ID.DROPDOWN_MENU" class="d-flex"
            [rlstTooltip]="disabled[1]" tooltipPosition="right">
            <button *ngIf="!isLoadStarted" type="button" (click)="loadLookups()" class="btn-custom btn-small">
              <i class="far fa-search"></i> Select from list
            </button>
            <ng-container *ngIf="isLoadStarted">
              <div *ngIf="!lookups" class="loading w-100" aria-hidden="true">
                <rlst-spinner-circle panelClass="spinner-small"></rlst-spinner-circle>
              </div>
              <ng-container *ngIf="isMultiValue(dataElement)">
                <rlst-multi-select [attr.aria-label]="dataElement.description" data-tooltip-position="above"
                  [rlstDisableFormControl]="disabled[0]" [lookUpData]="lookups"
                  [maxNumberSelection]="maxNumberMultiSelection$ | async" formControlName="valueFrom" class="w-100">
                </rlst-multi-select>
              </ng-container>
              <ng-container *ngIf="!isMultiValue(dataElement)">
                <rlst-select [attr.aria-label]="dataElement.description" data-tooltip-position="above"
                  [rlstDisableFormControl]="disabled[0]" [lookUpData]="lookups" formControlName="valueFrom"
                  class="w-100">
                </rlst-select>
              </ng-container>
            </ng-container>
          </div>

          <div *ngSwitchDefault class="d-flex" [rlstTooltip]="disabled[1]" tooltipPosition="right">
            <div class="aria-label-wrap" [attr.aria-label]="dataElement.description" data-tooltip-position="above">
              <input type="text" class="form-control search-form-control" formControlName="valueFrom"
                [attr.maxlength]="dataElement.maxLength === 0 ? null : dataElement.maxLength"
                [placeholder]="dataElement.displayInfo.elementMask || ''" [rlstDisableFormControl]="disabled[0]"
                [matAutocomplete]="auto" [readonly]="isFirst && isLimitReached(dataElement)">
            </div>


            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let option of recentSearches$ | async" [value]="option">
                {{option}}
              </mat-option>
            </mat-autocomplete>

            <div *ngIf="searchFieldGroup.get('operator').value === 'BETWEEN'" class="aria-label-wrap value-to-control"
              [attr.aria-label]="dataElement.description" data-tooltip-position="above">
              <input type="text" class="form-control search-form-control" formControlName="valueTo"
                [attr.maxlength]="dataElement.maxLength === 0 ? null : dataElement.maxLength"
                [rlstDisableFormControl]="disabled[0]" [readonly]="isFirst && isLimitReached(dataElement)">
            </div>
          </div>
        </div>
      </div>
      <div class="invalid-feedback" *ngIf="hasErrors(searchFieldGroup) as error">
        {{ error.message || getDatepickerErrorMessage()}}
      </div>
      <div class="form-control-actions"
        *ngIf="isMultiValue(dataElement) && !isSelectableField(dataElement.displayInfo.renderId)">
        <span
          [rlstTooltip]="isAddButtonDisabled(searchFieldGroup) ? 'To search multiple values, enter a value into the field(s) and click the Add(+) button' : 'Click to add a value to your search criteria'"
          tooltipPosition="above">
          <button *ngIf="isFirst" type="button" class="btn-custom btn-icon far fa-plus add-icon"
            [ngClass]="{'disabled-action': isLimitReached(dataElement) || !searchFieldGroup.valid}"
            [disabled]="isAddButtonDisabled(searchFieldGroup)" (click)="addField(searchFieldGroup, dataElement)">
          </button>
          <span class="sr-only">Add search item</span>
        </span>

        <button *ngIf="!isFirst" type="button" class="btn-custom btn-icon far fa-trash-alt trash-icon"
          rlstTooltip="Remove this Search Criteria" tooltipPosition="above" (click)="removeField(fieldIndex)">
          <span class="sr-only">Remove search item</span>
        </button>
      </div>
    </div>
  </fieldset>
</rlst-expandable-item>
